/**
 * dev-ops-aware-devices-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T23:28:47Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * describes the settings of a device
 */
export interface DeviceSettings { 
    batteryMeasurementIntervalSec: number;
    extremeOverloadMeasurementIntervalSec: number;
    extremeOverloadReportingIntervalSec: number;
    extremeOverloadThresholdDegC: number;
    nominalMeasurementIntervalSec: number;
    overloadMeasurementIntervalSec: number;
    overloadReportingIntervalSec: number;
    overloadThresholdDegC: number;
    rawMeasurementsEnabled: boolean;
    reportingIntervalSec: number;
}
